

import './Buttons.css';

const MikeyButton = ({ onSetCurrentPage }) => {

    return (
        <div
        className='mikey-mode'
        onClick={() => {

            setTimeout(() => {
                window.location.href = '/mikey-moo';
            }
            , 200);
        }}
        >
            <span className='mikey'>
                MIKEY MODE!
            </span>
            
        </div>

    )

};

export default MikeyButton;